import { useState, useCallback } from "react";
import { Modal, Dropdown, Form } from "semantic-ui-react";

import DialSessionService from "../../services/DialSessions";
import VoicemailService from "../../services/Voicemails";
import RuvixxForm from "../../components/RuvixxForm";

function CallBackUnlinkedModal({ call, onSuccess }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [voicemailOptions, setVoicemailOptions] = useState([]);
  const [voicemailId, setVoicemailId] = useState(null);

  const fetchVoicemails = useCallback(async () => {
    const voicemails = await VoicemailService.getVoicemailsForFilter();
    setVoicemailOptions(
      voicemails.map(vm => ({
        text: vm.name,
        key: vm.id,
        value: vm.id,
      }))
    );
  }, []);

  const handleOpen = () => {
    fetchVoicemails();
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setVoicemailId(null);
  };

  const handleSubmit = async () => {
    const sessionData = {
      name: `Callback ${call.external_number} - ${new Date().toISOString()}`,
      status: true,
      voicemail_id: voicemailId,
      info: {
        enable_recording: true,
      },
    };

    const dialerWindow = window.open(
      "about:blank",
      "_blank",
      "location=yes,height=750,width=1800,scrollbars=yes,status=yes"
    );

    if (!dialerWindow) {
      throw new Error(
        "Please allow popups for this site to use the callback feature."
      );
    }

    const dialSession =
      await DialSessionService.createPrivateSession(sessionData);

    const callbackParams = new URLSearchParams({
      private: "1",
      callback: "1",
      phone_number: call.external_number,
      voicemail_id: voicemailId,
      original_call_id: call.id,
    });

    dialerWindow.location.href = `/dialer/${dialSession.id}?${callbackParams.toString()}`;
  };

  const handleSuccess = () => {
    handleClose();
    if (onSuccess) onSuccess();
  };

  return (
    <Modal
      size="tiny"
      trigger={
        <Dropdown.Item onClick={handleOpen} content="Call" icon="call" />
      }
      open={modalOpen}
      onClose={handleClose}
      closeOnDimmerClick={false}
      closeIcon
    >
      <Modal.Header>Call Back Unlinked Number</Modal.Header>
      <Modal.Content>
        <p>
          Calling back: <strong>{call.external_number}</strong>
        </p>
        <RuvixxForm
          ready={!!voicemailId}
          onSubmit={handleSubmit}
          onSuccess={handleSuccess}
          submitButtonText="Start Call"
        >
          <Form.Select
            selectOnBlur={false}
            inline
            fluid
            required
            search
            onChange={(e, { value }) => setVoicemailId(value)}
            value={voicemailId}
            label="Voicemail"
            name="voicemailId"
            options={voicemailOptions}
            placeholder="Select Voicemail"
          />
        </RuvixxForm>
      </Modal.Content>
    </Modal>
  );
}

export default CallBackUnlinkedModal;
